import React from 'react'
import NumberFormat from 'react-number-format'

export default function InputMoeda({
  value,
  onChange,
  label,
  labelColor = '#652B2D',
  width = '100%',
  marginTop = 20,
}) {
  const styles = {
    container: {
      textAlign: 'left',
      marginTop,
    },
    label: {
      fontSize: '0.8rem',
      color: labelColor,
      display: 'block',
    },
    input: {
      width,
      outline: 'none',
      border: '1px solid rgb(196, 196, 196)',
      height: 30,
      marginTop: 3,
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      padding: 10,
    },
  }

  return (
    <div style={styles.container}>
      <label style={styles.label} htmlFor="myInput">
        {label}
      </label>
      <NumberFormat
        style={styles.input}
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={2}
        fixedDecimalScale={true}
        prefix={'R$'}
        isNumericString={true}
        value={value}
        onValueChange={values => onChange(values)}
      />
    </div>
  )
}
